<template>
    <div>
        <div v-if="ready && eventInfo">
            <div class="row">
                <div class="col-md-8">
                    <div class="q-display-1">Event: {{ eventInfo.name }}</div>
                </div>
                <div class="col-md-4 text-right">
                    <q-btn color="secondary" label="Refresh" icon="refresh" @click="getAttendees" class="q-mr-lg"></q-btn>
                    <q-btn color="primary" label="Add Attendee" icon="add" @click="registrationLink"></q-btn>
                </div>
            </div>
            <q-card class="mdi-card q-mb-lg">
                <q-card-main class="q-pa-none">
                    <q-list>
                        <q-collapsible icon="calendar_today" label="Event Info">
                            <div class="row q-mb-md shadow-1 q-pa-md">
                                <div class="col-md-2" v-if="eventInfo.eventType">
                                    <strong>Event Type:</strong>
                                    {{ eventInfo.eventType.name }}
                                </div>
                                <div class="col-md-2">
                                    <strong>For Members Only:</strong>
                                    {{ eventInfo.isMemberOnly | convertBool }}
                                </div>
                                <div class="col-md-2">
                                    <strong>Member Price:</strong>
                                    {{ eventInfo.memberPrice | money }}
                                </div>
                                <div class="col-md-2">
                                    <strong>Non Member Price:</strong>
                                    {{ eventInfo.nonMemberPrice | money }}
                                </div>
                                <div class="col-md-2">
                                    <strong>Register By:</strong>
                                    {{ eventInfo.registerBy | formatDate }}
                                </div>
                                <div class="col-md-2">
                                    <strong>Registration Enabled:</strong>
                                    {{ eventInfo.enableRegistration | convertBool }}
                                </div>
                            </div>
                            <div
                                    class="row q-mb-md shadow-1 q-pa-md"
                                    v-for="dates in eventInfo.eventDate"
                                    :key="dates.id"
                            >
                                <div class="col-md-2">
                                    <strong>Start:</strong>
                                    {{ dates.startDate | formatDate }}
                                </div>
                                <div class="col-md-2">
                                    <strong>End:</strong>
                                    {{ dates.endDate | formatDate }}
                                </div>
                                <div class="col-md-2">
                                    <strong>All Day:</strong>
                                    {{ dates.isAllDay | convertBool }}
                                </div>
                                <div class="col-md-2">
                                    <strong>Short Description:</strong>
                                    {{ dates.shortDescription }}
                                </div>
                            </div>
                            <div class="row shadow-1 q-pa-md" v-if="eventInfo.address">
                                <div class="col-md-4">
                                    <strong>Street 1:</strong>
                                    {{ eventInfo.address.line1 }}
                                </div>
                                <div class="col-md-2">
                                    <strong>Suite Number:</strong>
                                    {{ eventInfo.address.suiteNumber }}
                                </div>
                                <div class="col-md-2">
                                    <strong>City:</strong>
                                    {{ eventInfo.address.suiteNumber }}
                                </div>
                                <div class="col-md-2" v-if="eventInfo.address.state">
                                    <strong>City:</strong>
                                    {{ eventInfo.address.state.code }}
                                </div>
                                <div class="col-md-2">
                                    <strong>Zip:</strong>
                                    {{ eventInfo.address.zipCode }}
                                </div>
                            </div>
                        </q-collapsible>
                        <q-collapsible icon="info" :label="`Event Description`">
                            <div class="row shadow-1 q-pa-md">
                                <div class="col-md-12" v-html="eventInfo.description"></div>
                            </div>
                        </q-collapsible>
                    </q-list>
                </q-card-main>
            </q-card>
            <q-card class="mdi-card q-mb-lg">
                <q-card-main class="q-pa-none">
                    <!-- TABLE OF ATTENDEES -->
                    <q-table
                            v-if="attendees && attendees.length > 0 && dataColumns"
                            :data="curratedAttendees"
                            :columns="dataColumns"
                            row-key="id"
                            selection="multiple"
                            :selected.sync="selected"
                            dense
                            :visible-columns.sync="visibleColumnsModel"
                            :filter="terms"
                            :filter-method="myFilter"
                            :pagination.sync="pagination"
                            :rows-per-page-options="[0, 25, 50, 100, 250, 500]"
                    >
                        <div slot="top" slot-scope="props" class="full-width q-pt-sm q-pb-sm">
                            <transition
                                    mode="out-in"
                                    enter-active-class="animated flipInX"
                                    leave-active-class="animated flipOutX"
                            >
                                <!-- SEARCH -->
                                <div
                                        v-if="!selected.length"
                                        key="search-bar"
                                        class="row flex-center gutter-md"
                                        style="animation-duration: 0.4s"
                                >
                                    <div class="col-6">
                                        <q-search hide-underline v-model="terms"/>
                                    </div>
                                    <!-- ICONS -->
                                    <div class="col-3 text-right">
                                        <q-table-columns
                                                class="q-body-1 full-width"
                                                v-model="visibleColumnsModel"
                                                label="Visible Columns"
                                                :columns="columns"
                                        />
                                    </div>
                                    <div class="col text-right">
                                        <q-btn
                                                flat
                                                round
                                                dense
                                                :icon="props.inFullscreen ? 'fullscreen_exit' : 'fullscreen'"
                                                @click="props.toggleFullscreen"
                                        />
                                        <q-btn flat small round>
                                            <download-csv :data="exportData" :name="exportFileName">
                                                <q-icon name="file_download"/>
                                            </download-csv>
                                        </q-btn>
                                        <!--<q-btn flat small round icon="file_download">
                                          <q-tooltip>Download Excel</q-tooltip>
                                          <q-popover>
                                            <q-list separator link>
                                              <q-item v-close-overlay>
                                                &lt;!&ndash;<download-csv :data="exportData" :fields="exportFields">Download CSV</download-csv>&ndash;&gt;
                                                <download-csv :data="exportData">Download CSV</download-csv>
                                              </q-item>
                                              &lt;!&ndash;<q-item v-close-overlay>&ndash;&gt;
                                                 &lt;!&ndash;<download-csv :data="exportData">Download Other?</download-csv> &ndash;&gt;
                                              &lt;!&ndash;</q-item>&ndash;&gt;
                                            </q-list>
                                          </q-popover>
                                        </q-btn>-->
                                        <!-- <q-btn
                                           flat
                                           round
                                           dense
                                           :icon="props.inFullscreen ? 'fullscreen_exit' : 'fullscreen'"
                                           @click="props.toggleFullscreen"
                                         />-->
                                    </div>
                                </div>
                                <!-- BULK -->
                                <div
                                        key="bulk-update-bar"
                                        class="row flex-center gutter-md"
                                        style="animation-duration: 0.4s"
                                        v-else
                                >
                                    <!-- <div class="col">
                                      <q-select
                                        flat
                                        icon="edit"
                                        :options="[{label: '', value: ''}].concat(columnOptions)"
                                        v-model="selectedColumnsAction"
                                        placeholder="Select a field to mass update"
                                        hide-underline
                                        class="q-mr-sm no-shadow q-body-1"
                                        inverted-light
                                        :color="inputBgColor"
                                      ></q-select>
                                    </div>
                                    <div class="col" v-if="selectedColumnsAction && !readonly">
                                      <component
                                        :is="batchUpdateComponentColumn.component.is || 'q-input'"
                                        v-bind="batchUpdateComponentColumn.component.props"
                                        clearable
                                        v-model="selectedColumnsValue"
                                        :placeholder="batchUpdateComponentColumn.label"
                                        :column="batchUpdateComponentColumn"
                                        hide-underline
                                        class="no-shadow q-body-1"
                                        inverted-light
                                        :color="inputBgColor"
                                        @change="selectedColumnsValue = $event"
                                      />
                                    </div>
                                    <div class="col-1" v-if="!readonly">
                                      <q-btn
                                        v-if="selectedColumnsAction"
                                        :disabled="selectedColumnsValue === null || selectedColumnsValue === undefined"
                                        color="secondary"
                                        class="no-shadow on-right"
                                        push
                                        @click.native.prevent="handleBulkUpdate"
                                      >Apply</q-btn>
                                    </div>-->
                                    <div class="col text-right">
                                        <!-- <q-btn
                                          v-if="trashed"
                                          color="positive"
                                          flat
                                          label="Restore Selected"
                                          icon="restore"
                                          @click="handleBatchRestore"
                                        ></q-btn>-->
                                        <q-btn
                                                color="negative"
                                                flat
                                                delete
                                                label="Delete Selected"
                                                icon="delete"
                                                @click="handleBatchDelete"
                                        ></q-btn>
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <q-tr slot="header" slot-scope="props">
                            <q-th auto-width>
                                <q-checkbox
                                        v-if="props.multipleSelect"
                                        v-model="props.selected"
                                        indeterminate-value="some"
                                />
                            </q-th>
                            <q-th v-for="col in props.cols" :key="col.name" :props="props">{{ col.label }}</q-th>
                        </q-tr>
                        <!-- BODY -->
                        <template slot="body" slot-scope="props">
                            <q-tr
                                    :props="props"
                                    :class="[props.row.primaryRegistrant ? 'bg-grey-4' : 'bg-grey-1']"
                            >
                                <q-td auto-width>
                                    <q-checkbox color="primary" v-model="props.selected"/>
                                </q-td>
                                <q-td key="id" :props="props">
                                    <!-- @click="openEditModal(props.row.id)" -->
                                    <!-- @click="openBaseModal(props.row.id, 'personEvent')" -->
                                    <q-btn
                                            icon="edit"
                                            size="sm"
                                            flat
                                            color="primary"
                                            @click="openEditModal(props.row.id)"
                                    />
                                </q-td>
                                <q-td key="guest" :props="props">{{ props.row.person.guestData | convertBool }}</q-td>
                                <q-td key="purchaseId" :props="props">{{ props.row.purchase.id }}</q-td>
                                <q-td key="primaryRegistrant" :props="props">
                                    <template v-if="props.row.primaryRegistrant">
                                        <q-icon name="star"/>
                                    </template>
                                    <template v-else>
                                        <q-icon name="subdirectory_arrow_right"/>
                                    </template>
                                </q-td>
                                <q-td key="attending" :props="props">{{ props.row.attending | convertBool }}</q-td>
                                <q-td key="firstName" :props="props">
                                    <q-btn
                                            size="sm"
                                            flat
                                            color="primary"
                                            @click="openBaseModal(props.row.person.id, 'person')"
                                    >{{ props.row.person.firstName }}
                                    </q-btn>
                                </q-td>
                                <q-td key="lastName" :props="props">
                                    <q-btn
                                            size="sm"
                                            flat
                                            color="primary"
                                            @click="openBaseModal(props.row.person.id, 'person')"
                                    >{{ props.row.person.lastName }}
                                    </q-btn>
                                </q-td>
                                <q-td key="email" :props="props">
                                    <a :href="`mailto:${props.row.person.emailAddress}`">{{ props.row.person.emailAddress }}</a>
                                </q-td>
                                <q-td key="phone" :props="props">
                                    <a :href="`tel:${props.row.person.workNumber}`">{{ props.row.person.workNumber }}</a>
                                </q-td>
                                <q-td key="company" :props="props">
                                    <q-btn
                                            size="sm"
                                            flat
                                            color="primary"
                                            @click="openBaseModal(props.row.person.company.id, 'company')"
                                            v-if="props.row.person && props.row.person.company && props.row.person.company.name"
                                    >{{ props.row.person.company.name }}
                                    </q-btn>
                                </q-td>
                                <q-td
                                        key="dietOption"
                                        :props="props"
                                >{{ props.row.person.personDietOption | dietOptionDisplay }}
                                </q-td>
                                <q-td key="adaRequired" :props="props">
                                    <q-btn
                                            size="sm"
                                            flat
                                            :color="props.row.person.adaRequired ? 'primary' : 'secondary'"
                                            :label="props.row.person.adaRequired | convertBool"
                                    >
                                        <q-tooltip v-if="props.row.person.adaRequired">{{ props.row.person.adaComment }}</q-tooltip>
                                    </q-btn>
                                </q-td>
                                <q-td key="purchase" :props="props">
                                    <q-btn size="sm" flat color="primary" v-if="props.row.purchase && props.row.purchase.id">
                                        <q-popover>
                                            <q-list separator link>
                                                <q-item v-close-overlay @click.native="openBaseModal(props.row.purchase.id, 'purchase')">
                                                    View Record
                                                </q-item>
                                                <q-item v-close-overlay @click.native="openQuickbooksTransaction(props.row.purchase)">
                                                    Quickbooks Invoice/Sales Receipt
                                                </q-item>
                                                <!--<q-item v-close-overlay v-if="props.row.purchase && props.row.purchase.payment && props.row.purchase.payment[0] && props.row.purchase.payment[0].qbSysChargeId" @click.native="openMerchantTerminal(props.row.purchase.payment[0].qbSysChargeId)">
                                                    Open Merchant Terminal
                                                </q-item>-->
                                                <q-item v-close-overlay v-if="props.row.purchase && props.row.purchase.payment && props.row.purchase.payment[0] && props.row.purchase.payment[0].qbSysChargeId" @click.native="openMerchantTerminalDirect(props.row.purchase.payment[0].qbSysChargeId)">
                                                    Open Merchant Terminal
                                                </q-item>
                                                <!--<q-item v-close-overlay v-if="props.row.purchase.qbCustomerId" @click.native="openQuickbooksClient(props.row.purchase.qbCustomerId)">
                                                  View Client in Quickbooks
                                                </q-item>-->
                                            </q-list>
                                        </q-popover>
                                        {{ props.row.purchase.status | purchaseStatus }}
                                    </q-btn>
                                    <!--<q-btn
                                      size="sm"
                                      flat
                                      color="primary"
                                      @click="openBaseModal(props.row.purchase.id, 'purchase')"
                                    >{{ props.row.purchase.status | purchaseStatus }}</q-btn>-->
                                </q-td>
                                <q-td key="payment" :props="props">
                                    <q-btn
                                            v-if="props.row.purchase && props.row.purchase.payment && props.row.purchase.payment[0]"
                                            size="sm"
                                            flat
                                            color="primary"
                                            @click="openBaseModal(props.row.purchase.payment[0].id, 'payment')"
                                    >
                                        {{ props.row.purchase.payment[0].amount | money }}
                                    </q-btn>
                                    <q-btn
                                            v-else-if="props.row.purchase.amount"
                                            size="sm"
                                            flat
                                            color="primary"
                                            @click="openBaseModal(props.row.purchase.id, 'purchase')"
                                    >
                                        {{ props.row.purchase.amount | money }}
                                    </q-btn>
                                </q-td>
                                <q-td key="purchaseDate" :props="props">{{ props.row.purchase.date | formatDate }}</q-td>
                                <q-td key="sponsor" :props="props">
                                    <q-btn
                                            size="sm"
                                            color="primary"
                                            flat
                                            v-if="props.row.primaryRegistrant && props.row.purchase.sponsorshipPurchase && props.row.purchase.sponsorshipPurchase.length > 0"
                                            label="Yes"
                                    >
                                        <q-popover>
                                            <q-list separator link>
                                                <q-item
                                                        v-close-overlay
                                                        v-for="sponsorship in props.row.purchase.sponsorshipPurchase"
                                                        :key="sponsorship.id"
                                                        @click.native="openBaseModal(sponsorship.sponsorship.id, 'sponsorship')"
                                                >
                                                    {{
                                                    sponsorship.sponsorship.name
                                                    }}
                                                </q-item>
                                            </q-list>
                                        </q-popover>
                                    </q-btn>
                                    <q-btn size="sm" color="secondary" flat label="No" v-else/>
                                </q-td>
                                <q-td key="discount" :props="props">
                                    <q-btn
                                            size="sm"
                                            color="primary"
                                            flat
                                            v-if="props.row.primaryRegistrant && props.row.purchase.eventDiscountPurchase && props.row.purchase.eventDiscountPurchase.length > 0"
                                            label="Yes"
                                    >
                                        <q-popover>
                                            <q-list separator link>
                                                <q-item
                                                        v-close-overlay
                                                        v-for="discount in props.row.purchase.eventDiscountPurchase"
                                                        :key="discount.id"
                                                        @click.native="openBaseModal(discount.eventDiscount.id, 'eventDiscount')"
                                                >
                                                    {{
                                                    discount.eventDiscount.description
                                                    }}
                                                </q-item>
                                            </q-list>
                                        </q-popover>
                                    </q-btn>
                                    <q-btn size="sm" color="secondary" flat label="No" v-else/>
                                </q-td>
                                <template v-if="props.row.comment && props.row.comment.length < 40">
                                    <q-td key="comment" :props="props">{{ props.row.comment }}</q-td>
                                </template>
                                <template v-else-if="props.row.comment && props.row.comment.length > 40">
                                    <q-td key="comment" :props="props">
                                        <!--<q-checkbox
                                          color="primary"
                                          v-model="props.expand"
                                          v-if="props.row.comment && props.row.comment.length > 0"
                                          checked-icon="expand_less"
                                          unchecked-icon="expand_more"
                                          class="q-mr-md"
                                          label="View Comment"
                                        />-->
                                        <q-btn
                                                size="sm"
                                                flat
                                                color="primary"
                                                @click="openTextModal(props.row.comment)"
                                        >
                                            {{ props.row.comment.substring(0, 20) }}...
                                        </q-btn>
                                    </q-td>
                                </template>
                                <template v-else>
                                    <q-td key="comment" :props="props">{{ props.row.comment }}</q-td>
                                </template>
                                <q-td
                                        :props="props"
                                        v-for="customQuestion in customQuestionColumns(props.cols)"
                                        :key="customQuestion.name"
                                >
                                    <template v-if="getQuestion(customQuestion).questionType === 'address' && customQuestionAnswer(customQuestion, props.row.answer)">
                                        <q-btn
                                                size="sm"
                                                flat
                                                color="primary"
                                                @click="openBaseModal(customQuestionAnswer(customQuestion, props.row.answer), 'address')"
                                        >
                                            {{ props.row.answer[findAnswerIndex(getQuestion(customQuestion), props.row.answer)].address.line1 }}
                                        </q-btn>
                                    </template>
                                    <template v-else-if="getQuestion(customQuestion).questionType === 'text' && customQuestionAnswer(customQuestion, props.row.answer)">
                                        <template v-if="customQuestionAnswer(customQuestion, props.row.answer).length < 40">
                                            {{ customQuestionAnswer(customQuestion, props.row.answer) }}
                                        </template>
                                        <template v-else-if="props.row.comment && props.row.comment.length > 40">
                                            <q-btn
                                                    size="sm"
                                                    flat
                                                    color="primary"
                                                    @click="openTextModal(customQuestionAnswer(customQuestion, props.row.answer), 'text')"
                                            >
                                                {{ customQuestionAnswer(customQuestion, props.row.answer).substring(0, 20) }}...
                                            </q-btn>
                                        </template>
                                    </template>
                                    <template v-else>{{ customQuestionAnswer(customQuestion, props.row.answer) }}</template>
                                </q-td>
                            </q-tr>
                            <!-- EXPAND -->
                            <!--<q-tr v-show="props.expand" :props="props">
                              <q-td colspan="100%" style="white-space: pre-wrap">
                                <div class="text-left">{{ props.row.comment }}</div>
                              </q-td>
                            </q-tr>-->
                        </template>
                    </q-table>
                    <q-alert type="negative" v-else>No attendees found for this event</q-alert>
                    <!-- END TABLE OF ATTENDEES -->
                </q-card-main>
            </q-card>
            <q-inner-loading :visible="loading"></q-inner-loading>
        </div>
        <!-- BASE FORM -->
        <div v-if="baseFormModalOpen">
            <q-modal
                    v-model="baseFormModalOpen"
                    content-classes="q-pa-lg"
                    content-css="min-width: 70vw; max-width: 95vw"
                    no-backdrop-dismiss
                    no-esc-dismiss
            >
                <div class="fit">
                    <q-btn
                            flat
                            icon="close"
                            class
                            style="top: 0; right: 0; position: relative; float: right"
                            @click="baseFormModalOpen = false"
                    ></q-btn>
                    <div v-if="baseFormModelId">
                        <base-form
                                v-if="relationResource"
                                :resource="relationResource"
                                :callback="handleBaseEdit"
                                :is-modal="true"
                                :id="baseFormModelId"
                                @add="handleNew"
                        >
                            <div slot="goback" class="full-width q-mt-md q-pb-lg">
                                <q-btn
                                        icon="close"
                                        label="Cancel / Close"
                                        color="grey-6"
                                        @click="baseFormModalOpen = false"
                                        flat
                                />
                            </div>
                        </base-form>
                    </div>
                </div>
            </q-modal>
        </div>
        <!-- Text MODAL FORM -->
        <div v-if="textModalOpen">
            <q-modal
                    v-model="textModalOpen"
                    content-classes="q-pa-lg"
                    content-css="min-width: 70vw; max-width: 95vw"
                    no-backdrop-dismiss
                    no-esc-dismiss
            >
                <div class="fit">
                    <q-btn
                            flat
                            icon="close"
                            class
                            style="top: 0; right: 0; position: relative; float: right"
                            @click="textModalOpen = false"
                    ></q-btn>
                    <div v-if="textModalText">
                        {{ textModalText }}
                    </div>
                    <q-btn
                            class="q-mt-lg"
                            color="primary"
                            @click="textModalOpen = false"
                            label="Close"
                    />
                </div>
            </q-modal>
        </div>
        <!-- EDIT FORM -->
        <div v-if="editFormModalOpen">
            <q-modal
                    v-model="editFormModalOpen"
                    content-classes="q-pa-lg"
                    content-css="min-width: 70%; max-width: 95vw"
                    no-route-dismiss
                    no-esc-dismiss
                    no-backdrop-dismiss
            >
                <div class="fit" v-if="editForm && editForm.person">
                    <q-btn
                            flat
                            icon="close"
                            class
                            style="top: 0; right: 0; position: relative; float: right"
                            @click="editFormModalOpen = false"
                    ></q-btn>
                    <div>
                        <h4>Edit Attendee</h4>
                        <div class="mdi-card full-width q-pa-md">
                            <form @submit.prevent="saveAttendee">
                                <div class="row">
                                    <!-- ROW 1 -->
                                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <q-field
                                                orientation="vertical"
                                                label="Attendee"
                                                class="q-pa-md"
                                                :error="errors.has(`person`, validatorFormName)"
                                                :error-label="errors.first(`person`, validatorFormName)"
                                                helper="Person attending"
                                                :icon-color="errors.has(`person`, validatorFormName) ? 'negative' : true ? fieldColor : inputBgColor"
                                                :class="{ 'is-required': true }"
                                                icon="star"
                                        >
                                            <q-btn
                                                    flat
                                                    color="primary"
                                                    @click="openAttendeeBaseModal(editForm.id)"
                                            >{{ editForm.person.firstName }} {{ editForm.person.lastName }}
                                            </q-btn>
                                        </q-field>
                                    </div>
                                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <q-field
                                                orientation="vertical"
                                                label="Primary Registrant"
                                                class="q-pa-md"
                                                inset="full"
                                                icon="edit"
                                                :icon-color="inputBgColor"
                                                helper="The person who filled in the registration form.  If you change this, it potentially could change a different person's record."
                                                v-if="editForm.purchase && editForm.purchase.id"
                                        >
                                            <q-toggle
                                                    v-model="editForm.primaryRegistrant"
                                                    :true-value="true"
                                                    :false-value="false"
                                                    name="primaryRegistrant"
                                            />
                                        </q-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <!-- ROW 2 -->
                                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <q-field
                                                orientation="vertical"
                                                label="Comment"
                                                class="q-pa-md"
                                                inset="full"
                                                icon="edit"
                                                :icon-color="inputBgColor"
                                        >
                                            <q-input
                                                    v-model="editForm.comment"
                                                    type="textarea"
                                                    name="comment"
                                                    class="no-shadow"
                                                    hide-underline
                                                    inverted-light
                                                    :color="inputBgColor"
                                                    helper="Registrant's comment."
                                            />
                                        </q-field>
                                    </div>
                                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <q-field
                                                orientation="vertical"
                                                label="Attending"
                                                class="q-pa-md"
                                                inset="full"
                                                icon="edit"
                                                :icon-color="inputBgColor"
                                                helper="Is this person attending the event?"
                                        >
                                            <q-toggle
                                                    v-model="editForm.attending"
                                                    :true-value="true"
                                                    :false-value="false"
                                                    name="attending"
                                            />
                                        </q-field>
                                    </div>
                                </div>
                                <template>
                                    <div class="row">
                                        <div
                                                class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                                                v-for="question in sortedQuestions"
                                                :key="question.id"
                                                v-if="(!question.appliesToAll && editForm.primaryRegistrant) || question.appliesToAll"
                                        >
                                            <q-field
                                                    orientation="vertical"
                                                    :label="question.questionText"
                                                    class="q-pa-md"
                                                    :error="errors.has(`q_${question.id}`, validatorFormName)"
                                                    :error-label="errors.first(`q_${question.id}`, validatorFormName)"
                                                    :helper="question.invoiceDesc"
                                                    :icon-color="errors.has(`q_${question.id}`, validatorFormName) ? 'negative' : question.required ? fieldColor : inputBgColor"
                                                    :class="{ 'is-required': question.required }"
                                                    :icon="question | fieldIcon(errors, validatorFormName)"
                                            >
                                                <template v-if="question.questionType === 'address'">
                                                    <q-btn
                                                            flat
                                                            color="primary"
                                                            @click="editFormAddress(question)"
                                                            v-if="findAnswerIndex(question) >= 0"
                                                    >
                                                        <span v-if="editForm.answer[findAnswerIndex(question)].address && editForm.answer[findAnswerIndex(question)].address.line1">{{ editForm.answer[findAnswerIndex(question)].address.line1 }}</span>
                                                        <span v-else>Add Address</span>
                                                    </q-btn>
                                                    <q-btn
                                                            flat
                                                            color="primary"
                                                            @click="editFormAddress(question)"
                                                            v-else
                                                    >
                                                        Add Address
                                                    </q-btn>
                                                    <!-- BASE FORM ADDRESS -->
                                                    <div v-if="editFormModalOpen">
                                                        <q-modal
                                                                v-model="attendeeAddressBaseFormModalOpen"
                                                                content-classes="q-pa-lg"
                                                                content-css="min-width: 70vw; max-width: 95vw"
                                                                no-backdrop-dismiss
                                                                no-esc-dismiss
                                                        >
                                                            <div class="fit">
                                                                <q-btn
                                                                        flat
                                                                        icon="close"
                                                                        class
                                                                        style="top: 0; right: 0; position: relative; float: right"
                                                                        @click="attendeeAddressBaseFormModalOpen = false"
                                                                ></q-btn>
                                                                <div>
                                                                    <!-- v-if="editFormModalOpen && attendeeAddressBaseFormModalOpen" -->
                                                                    <base-form
                                                                            resource="answer"
                                                                            :is-modal="true"
                                                                            :id="editForm.answer[findAnswerIndex(question)].id"
                                                                            :return-form="true"
                                                                            :no-save="true"
                                                                            :queue="false"
                                                                            @add="handleNew"
                                                                            v-on:add="updateEditFormAddress"
                                                                    >
                                                                        <div slot="goback" class="full-width q-mt-md q-pb-lg">
                                                                            <q-btn
                                                                                    icon="close"
                                                                                    label="Cancel / Close"
                                                                                    color="grey-6"
                                                                                    @click="attendeeAddressBaseFormModalOpen = false"
                                                                                    flat
                                                                            />
                                                                        </div>
                                                                    </base-form>
                                                                </div>
                                                            </div>
                                                        </q-modal>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <component
                                                            v-validate="question && question.required ? 'required' : ''"
                                                            :validator-form-name="validatorFormName"
                                                            :data-vv-scope="validatorFormName"
                                                            :data-vv-name="`q_${question.id}`"
                                                            class="no-shadow"
                                                            hide-underline
                                                            :color="errors.has(`q_${question.id}`) ? 'negative' : inputBgColor"
                                                            inverted-light
                                                            :is="question.questionType | questionComponent"
                                                            :value="findAnswerIndex(question) >= 0 && findAnswerType(question) ? editForm.answer[findAnswerIndex(question)][findAnswerType(question)] : null"
                                                            :options="getSelectOptions(question)"
                                                            @change="handleCustomInputChange(findAnswerIndex(question), findAnswerType(question), $event)"
                                                            @input="handleCustomInputChange(findAnswerIndex(question), findAnswerType(question), $event)"
                                                            type="textarea"
                                                    ></component>
                                                </template>
                                            </q-field>
                                        </div>
                                    </div>
                                </template>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <q-btn
                                                color="primary"
                                                @click="saveAttendee"
                                                class="full-width"
                                                push
                                                size="lg"
                                                :disabled="false"
                                        >Save
                                        </q-btn>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <q-btn
                                class="q-mt-lg"
                                color="primary"
                                @click="editFormModalOpen = false"
                                label="Close"
                        />
                    </div>
                </div>
                <!-- BASE FORM ATTENDEE -->
                <div v-if="editFormModalOpen">
                    <q-modal
                            v-model="attendeeBaseFormModalOpen"
                            content-classes="q-pa-lg"
                            content-css="min-width: 70vw; max-width: 95vw"
                            no-backdrop-dismiss
                            no-esc-dismiss
                    >
                        <div class="fit">
                            <q-btn
                                    flat
                                    icon="close"
                                    class
                                    style="top: 0; right: 0; position: relative; float: right"
                                    @click="attendeeBaseFormModalOpen = false"
                            ></q-btn>
                            <div>
                                <!--v-if="editFormModalOpen && attendeeBaseFormModalOpen"-->
                                <base-form
                                        resource="personEvent"
                                        :is-modal="true"
                                        :id="this.editForm.id"
                                        :return-form="true"
                                        :no-save="true"
                                        :queue="false"
                                        @add="handleNew"
                                        v-on:add="updateEditFormAttendee"
                                >
                                    <div slot="goback" class="full-width q-mt-md q-pb-lg">
                                        <q-btn
                                                icon="close"
                                                label="Cancel / Close"
                                                color="grey-6"
                                                @click="attendeeBaseFormModalOpen = false"
                                                flat
                                        />
                                    </div>
                                </base-form>
                            </div>
                        </div>
                    </q-modal>
                </div>
            </q-modal>
        </div>
    </div>
</template>

<script>
import {dateFormat} from '../../plugins/filters'
import {openURL, extend, date} from 'quasar'
import downloadCsv from 'vue-json-csv'
import {snakeCase, titleCase} from 'change-case'
import environmentMixin from '../../mixins/environment'

export default {
  name: 'EventAttendees',
  components: {downloadCsv},
  mixins: [environmentMixin],
  props: {
    eventId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      ready: false,
      open: false,
      attendees: [],
      eventInfo: {},
      selected: [],
      filter: '',
      terms: '',
      textModalOpen: false,
      textModalText: '',
      editForm: {},
      editFormModalOpen: false,
      editFormModelId: '',
      baseFormModalOpen: false,
      baseFormModelId: '',
      attendeeBaseFormModalOpen: false,
      attendeeBaseFormModelId: '',
      attendeeAddressBaseFormModalOpen: false,
      attendeeAddressBaseFormModelId: '',
      attendeeAddressEditFormAnswerIndex: false,
      customQuestionAddressModals: [],
      attendeeBaseFormKey: 0,
      validatorFormName: 'personEvent',
      relationResource: 'person',
      inputBgColor: 'blue-grey-1',
      errorBg: 'negative',
      fieldColor: 'blue-5',
      blankProps: {
        config: {
          params: {}
        }
      },
      massSelectOptionSelected: null,
      massSelectOptions: [
        {label: '', value: ''}
      ],
      deletePurchaseRecords: [],
      pagination: {
        // sortBy: 'id', // String, column "name" property value
        sortBy: null,
        descending: false,
        page: 1,
        rowsPerPage: 500 // current rows per page being displayed
      },
      columns: [
        {name: 'id', label: 'Edit', field: 'id', sortable: false, align: 'left'},
        {name: 'guest', label: 'Guest', field: x => x.person.guestData ? 'Yes' : 'No', sortable: true, align: 'left'},
        {name: 'purchaseId', label: 'ID', field: x => x.purchase.id, sortable: true, align: 'left'},
        {name: 'primaryRegistrant', label: 'Prime', field: 'primaryRegistrant', sortable: true, align: 'left', sort: (a, b) => (a === b) ? 0 : a ? -1 : 1},
        {name: 'attending', label: 'Attending', field: 'attending', sortable: true, align: 'left', sort: (a, b) => (a === b) ? 0 : a ? -1 : 1},
        {name: 'firstName', label: 'First Name', field: x => x.person.firstName, sortable: true, align: 'left'},
        {name: 'lastName', label: 'Last Name', field: x => x.person.lastName, sortable: true, align: 'left'},
        // { name: 'phone', label: 'Phone', field: x => x.person.workNumber, sortable: true },
        {name: 'email', label: 'Email', field: x => x.person.emailAddress, sortable: true, align: 'left'},
        {name: 'phone', label: 'Phone', field: x => x.person.workNumber, sortable: true, align: 'left'},
        {name: 'company', label: 'Company', field: x => x.person.company.name, sortable: true, align: 'left'},
        {name: 'dietOption', label: 'Diet', field: x => x.person.personDietOption ? x.person.personDietOption.length : 0, sortable: true, align: 'left'},
        {name: 'adaRequired', label: 'ADA', field: x => x.person.adaRequired, sortable: true, align: 'left', sort: (a, b) => (a === b) ? 0 : a ? -1 : 1},
        {name: 'purchase', label: 'Purchase', field: x => x.purchase.status, sortable: true, align: 'left'},
        {name: 'payment', label: 'Payment', field: x => x.purchase && x.purchase.payment && x.purchase.payment[0] ? x.purchase.payment[0].amount : x.purchase.amount, sortable: true, align: 'left'},
        {name: 'purchaseDate', label: 'Purchase Date', field: x => x.purchase.date, sortable: true, align: 'left'},
        // { name: 'sponsor', label: 'Sponsor', field: x => x.purchase.sponsorshipPurchase, sortable: true, align: 'left' },
        {name: 'sponsor', label: 'Sponsor', field: x => x.purchase.sponsorshipPurchase ? x.purchase.sponsorshipPurchase.length : 0, sortable: true, align: 'left'},
        // { name: 'discount', label: 'Discount', field: x => x.purchase.eventDiscountPurchase, sortable: true, align: 'left' },
        {name: 'discount', label: 'Discount', field: x => x.purchase.eventDiscountPurchase ? x.purchase.eventDiscountPurchase.length : 0, sortable: true, align: 'left'},
        {name: 'comment', label: 'Comment', field: 'comment', sortable: true, align: 'left'}
      ],
      visibleColumns: ['id', 'guest', 'primaryRegistrant', 'attending', 'firstName', 'lastName', 'email', 'phone', 'company', 'dietOption', 'adaRequired', 'purchase', 'payment', 'purchaseDate', 'purchaseId', 'sponsor', 'discount', 'comment'],
      exportFields: ['registrationId', 'primaryRegistrant', 'attending', 'firstName', 'lastName', 'email', 'phone', 'company', 'dietOption', 'adaRequired']
    }
  },
  async created () {
    await this.getEvent()
    await this.getAttendees()
    this.ready = true
    this.loading = false
  },
  computed: {
    visibleColumnsModel: {
      get () {
        return this.visibleColumns
        //   return this.visibleColumns.reduce((arr, column) => {
        //     if (column && column.field) {
        //       arr.push(column.field)
        //     }
        //     return arr
        //   }, [])
      },
      set (payload) {
        // console.log('...visible', payload)
        // this.$store.commit(`${this.resource}/SET_SETTING`, {
        //   field: 'visibleColumns',
        //   value: payload
        // })
        // this.visibleColumns.push(payload[0])
        this.visibleColumns = payload
      }
    },
    curratedAttendees () {
      if (this.attendees && this.attendees.length > 0) {
        let attendees = this.attendees.map(value => {
          let i = value
          if (value.person.id === value.purchase.personId) {
            i.primaryRegistrant = true
          } else {
            i.primaryRegistrant = false
          }
          return i
        })
        // Group registrations with the primary registrant on top
        return attendees.sort((attendees1, attendees2) => {
          if (attendees1.purchase.id < attendees2.purchase.id) return -1
          if (attendees1.purchase.id > attendees2.purchase.id) return 1
          if (attendees1.primaryRegistrant < attendees2.primaryRegistrant) return 1
          if (attendees1.primaryRegistrant > attendees2.primaryRegistrant) return -1
        })
      }
      return null
    },
    sortedQuestions () {
      let sorted = false
      if (this.eventInfo && this.eventInfo.question && this.eventInfo.question.length) {
        sorted = this.eventInfo.question
        sorted.sort((a, b) => a.sort - b.sort)
      }
      return sorted
    },
    dataColumns () {
      let columns = this.columns
      if (this.sortedQuestions && this.sortedQuestions.length) {
        for (let question of this.sortedQuestions) {
          // let obj = { name: `q_${question.id}`, label: question.questionText, field: x => x.person.answer, sortable: true, align: 'left' }
          let obj = {name: `q_${question.id}`, label: question.questionText, field: x => question.questionType === 'address' ? this.customQuestionAnswer(question, x.answer, true, false, 'line1') : this.customQuestionAnswer(question, x.answer, true, false), sortable: true, align: 'left'}
          columns.push(obj)
        }
      }
      return columns
    },
    exportFileName () {
      if (this.eventInfo.name) {
        let startDate = '_'
        if (this.eventInfo.eventDate && this.eventInfo.eventDate[0] && this.eventInfo.eventDate[0].startDate) {
          startDate = startDate + date.formatDate(this.eventInfo.eventDate[0].startDate, 'MM-DD-YYYY')
        }
        return snakeCase(this.eventInfo.name + '_export' + startDate) + '.csv'
      }
      return 'Attendees Export'
    },
    exportData () {
      if (this.attendees && this.attendees.length > 0) {
        let attendees = this.attendees.map(value => {
          let i = {}
          i.Registration_Id = value.purchase && value.purchase.id ? value.purchase.id : null
          if (this.eventInfo && this.eventInfo.eventType && this.eventInfo.eventType.id === 2) {
            i.Team_Name = value.eventTeam && value.eventTeam.teamName ? value.eventTeam.teamName : null
          }
          i.Primary_Registrant = value.primaryRegistrant ? 'Yes' : 'No'
          i.Attending = value.attending ? 'Yes' : 'No'
          i.First_Name = value.person && value.person.firstName ? value.person.firstName : null
          i.Last_Name = value.person && value.person.lastName ? value.person.lastName : null
          i.Company_Name = value.person && value.person.company && value.person.company.name ? value.person.company.name : null
          i.Email = value.person && value.person.emailAddress ? value.person.emailAddress : null
          i.Phone = value.person && value.person.workNumber ? value.person.workNumber : null
          i.Diet_Option = value.person && value.person.personDietOption && value.person.personDietOption.length ? this.dietOptionDisplayMethod(value.person.personDietOption) : null
          i.Diet_Comment = value.person && value.person.dietComment ? value.person.dietComment : null
          i.ADA_Required = value.person && value.person.adaRequired ? 'Yes' : 'No'
          i.ADA_Comment = value.person && value.person.adaComment ? value.person.adaComment : null
          i.Comment = value.comment ? value.comment : null
          // i.Company_Address_Line1 = value.person && value.person.company && value.person.company.address && value.person.company.address.line1 ? value.person.company.address.line1 : null
          // i.Company_Address_Suite_Number = value.person && value.person.company && value.person.company.address && value.person.company.address.suiteNumber ? value.person.company.address.suiteNumber : null
          // i.Company_Address_City = value.person && value.person.company && value.person.company.address && value.person.company.address.city ? value.person.company.address.city : null
          // i.Company_Address_State = value.person && value.person.company && value.person.company.address && value.person.company.address.state && value.person.company.address.state.code ? value.person.company.address.state.code : null
          i.Purchase_Status = value.purchase && value.purchase.status && value.primaryRegistrant ? value.purchase.status : null
          i.Purchase_Amount = value.purchase && value.purchase.amount && value.primaryRegistrant ? value.purchase.amount : null
          i.Purchase_Discount = value.purchase && value.purchase.eventDiscountPurchase && value.primaryRegistrant ? this.exportEventDiscount(value.purchase.eventDiscountPurchase) : null
          i.Purchase_Sponsorship = value.purchase && value.purchase.sponsorshipPurchase && value.primaryRegistrant ? this.exportSponsorship(value.purchase.sponsorshipPurchase) : null
          if (value.answer && value.answer.length && this.sortedQuestions && this.sortedQuestions.length) {
            for (let question of this.sortedQuestions) {
              // let propName = this.convertToProp(question.questionText)
              let propName = this.convertToProp(question.invoiceDesc)
              // let answerIndex = this.findAnswerIndex(question, value.answer)
              let answerType = this.findAnswerType(question)
              if (answerType === 'addressId') {
                let address = this.customQuestionAnswer(question, value.answer, true, true)
                // console.log('address', address)
                if (address) {
                  i[propName + '_Line_1'] = address.line1
                  i[propName + '_Suite_Number'] = address.suiteNumber
                  i[propName + '_City'] = address.city
                  if (address.state && address.state.code) {
                    i[propName + '_State'] = address.state.code
                  }
                  i[propName + '_Zip'] = address.zipCode
                } else {
                  i[propName + '_Line_1'] = ''
                  i[propName + '_Suite_Number'] = ''
                  i[propName + '_City'] = ''
                  i[propName + '_State'] = ''
                  i[propName + '_Zip'] = ''
                }
              } else {
                i[propName] = this.customQuestionAnswer(question, value.answer, true, true)
              }
            }
          }
          return i
        })
        return attendees.sort((attendees1, attendees2) => {
          if (attendees1.Registration_Id < attendees2.Registration_Id) return -1
          if (attendees1.Registration_Id > attendees2.Registration_Id) return 1
          if (attendees1.Primary_Registrant < attendees2.Primary_Registrant) return 1
          if (attendees1.Primary_Registrant > attendees2.Primary_Registrant) return -1
        })
      }
      return null
    },
    exportName () {
      if (this.eventInfo && this.eventInfo.name) {
        return this.eventInfo.name
      }
    }
  },
  filters: {
    formatDate (date) {
      return dateFormat(date)
    },
    convertBool (val) {
      if (val) {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    purchaseStatus (value) {
      if (value) {
        return value
      }
      return 'NO STATUS'
    },
    dietOptionDisplay (optionsArray) {
      if (Array.isArray(optionsArray) && optionsArray.length > 0) {
        let dietOptions = optionsArray.map(value => {
          let i = value.dietOption && value.dietOption.description ? value.dietOption.description : null
          return i
        })
        return dietOptions.join(', ')
      }
      return 'None'
    },
    questionComponent (questionType) {
      if (questionType === 'text') {
        return 'q-input'
      } else if (questionType === 'bool') {
        return 'q-toggle'
      } else if (questionType === 'select') {
        return 'q-select'
      } else if (questionType === 'address') {
        return 'address'
      }
    },
    fieldIcon (question, errors, validatorFormName) {
      let icon = 'edit'
      // console.log('question', question)
      if (question && question.required) {
        icon = errors.has(`q_${question.id}`, validatorFormName) ? 'star_border' : 'star'
      }
      return icon
    }
  },
  methods: {
    // handleBaseCancel() {
    //   this.$store.commit(`${this.resource}/SET_QUICK_EDIT`, null)
    //   this.isModalOpen = false
    // },
    // baseFormChange (model) {
    //   console.log('baseFormChange', model)
    // },
    // baseFormAdd (model) {
    //   console.log('baseFormAdd', model)
    // },
    // baseFormSave (data) {
    //   console.log('baseFormSave', data)
    // },
    async doCopy (string, message = 'Value Copied') {
      let self = this
      this.$copyText(string).then(
        function (e) {
          if (message) {
            self.$q.notify({
              type: 'positive',
              message: message
            })
          }
          console.log(e)
        },
        function (e) {
          alert('Can not copy')
          console.log(e)
        }
      )
    },
    openQuickbooksClient (qbCustomerId) {
      let finalUrl = this.quickbooksBaseUrl + `customerdetail?nameId=${qbCustomerId}`
      openURL(finalUrl)
    },
    openQuickbooksTransaction (purchase) {
      let postUrl = ''
      if (purchase.qbSalesReceiptId) {
        postUrl = `salesreceipt?txnId=${purchase.qbSalesReceiptId}`
      } else if (purchase.qbInvoiceId) {
        postUrl = `invoice?txnId=${purchase.qbInvoiceId}`
      }
      let finalUrl = this.quickbooksBaseUrl + postUrl
      openURL(finalUrl)
    },
    openMerchantTerminal (qbSysChargeId) {
      this.doCopy(qbSysChargeId, '')
      // let finalUrl = this.merchantCenterUrl + `reporting#transaction/${qbSysChargeId}`
      // let finalUrl = this.merchantCenterTransactionUrl + qbSysChargeId
      this.$q.dialog({
        title: 'Go to Transaction',
        message: `Transaction ID Copied. You will be routed to Quickbooks Merchant Center. Be sure to use the advanced search for transaction ID: ${qbSysChargeId}`,
        ok: 'Go',
        cancel: 'Stay'
      }).then(() => {
        let finalUrl = 'https://merchantcenter.intuit.com/msc/portal/reporting'
        // console.log('finalUrl', finalUrl)
        openURL(finalUrl)
        // this.$q.notify('Agreed!')
      }).catch(() => {
        // this.$q.notify('Disagreed...')
      })
    },
    openMerchantTerminalDirect (qbSysChargeId) {
      // let finalUrl = this.merchantCenterUrl + `reporting#transaction/${qbSysChargeId}`
      let finalUrl = this.merchantCenterTransactionUrl + qbSysChargeId
      // console.log('finalUrl', finalUrl)
      openURL(finalUrl)
    },
    convertToProp (value) {
      let modifiedValue = titleCase(snakeCase(value))
      modifiedValue = modifiedValue.replace(/\s+/g, '_')
      // console.log('modifiedValue', modifiedValue, 'Original', value, 'title', titleCase(modifiedValue))
      return modifiedValue
    },
    exportEventDiscount (sponsorshipPurchase) {
      let returnString = ''
      for (let sp of sponsorshipPurchase) {
        if (sp.purchaseId && sp.eventDiscount) {
          returnString += sp.eventDiscount.description
          if (sp.eventDiscount.value) {
            returnString += ` | Discounted Value: ${sp.eventDiscount.value}`
          }
          if (sp.eventDiscount.percent) {
            returnString += ` | Discounted Percent: ${sp.eventDiscount.percent}%`
          }
          returnString += `\n`
        }
      }
      if (sponsorshipPurchase.length) {
        return returnString.slice(0, -2)
      } else {
        return returnString
      }
    },
    exportSponsorship (discountPurchase) {
      let returnString = ''
      for (let dp of discountPurchase) {
        if (dp.purchaseId && dp.sponsorship) {
          returnString += dp.sponsorship.name
          if (dp.sponsorship.freeSlotCount) {
            returnString += ` | Free Slots: ${dp.sponsorship.freeSlotCount}`
          }
          if (dp.sponsorship.memberPrice) {
            returnString += ` | Member Price: $${dp.sponsorship.memberPrice}`
          }
          if (dp.sponsorship.nonMemberPrice) {
            returnString += ` | Non Member Price: $${dp.sponsorship.nonMemberPrice}`
          }
          returnString += `\n`
        }
      }
      if (discountPurchase.length) {
        return returnString.slice(0, -1)
      } else {
        return returnString
      }
    },
    handleCustomInputChange (answerIndex, answerType, data) {
      // console.log('answerIndex', answerIndex)
      // console.log('answerType', answerType)
      // console.log('data', data)
      this.editForm.answer[answerIndex][answerType] = data
    },
    findAnswerType (question) {
      let answerType = 'openAnswer'
      if (question.questionType === 'text') {
        answerType = 'openAnswer'
      } else if (question.questionType === 'bool') {
        answerType = 'boolAnswer'
      } else if (question.questionType === 'select') {
        answerType = 'selectAnswer'
      } else if (question.questionType === 'address') {
        answerType = 'addressId'
      }
      return answerType
    },
    findAnswerIndex (question, answer = false) {
      let index = ''
      if (answer) {
        index = answer.findIndex(a => a.questionId === question.id)
      } else {
        index = this.editForm.answer.findIndex(a => a.questionId === question.id)
      }
      // console.log('editForm.answer index', index, this.editForm.answer[index])
      return index
    },
    dietOptionDisplayMethod (optionsArray) {
      if (Array.isArray(optionsArray) && optionsArray.length > 0) {
        let dietOptions = optionsArray.map(value => {
          let i = value.dietOption && value.dietOption.description ? value.dietOption.description : null
          return i
        })
        return dietOptions.join(', ')
      }
      return null
    },
    convertBoolMethod (val) {
      if (val) {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    getQuestionId (question) {
      if (question && question.name) {
        return parseInt(question.name.substr(2))
      }
      return false
    },
    getQuestion (tableQuestion) {
      let fullQuestion = false
      const questionId = this.getQuestionId(tableQuestion)
      if (questionId) {
        fullQuestion = this.sortedQuestions.filter(q => q.id === questionId)[0]
      }
      return fullQuestion
    },
    customQuestionAnswer (question, answer, fullQuestionProvided = false, fullAddress = false, addressPropReturn = false) {
      // console.log('=========== customQuestionAnswer ==========')
      // console.log('question', question)
      // console.log('answer', answer)
      let finalAnswer = ''
      if ((question && question.name && answer && answer.length) || fullQuestionProvided) {
        let questionId = false
        if (fullQuestionProvided) {
          questionId = question.id
        } else {
          questionId = this.getQuestionId(question)
        }
        // const fullQuestion = this.getQuestion(question)
        if (questionId) {
          // console.log('questionId', questionId)
          let matchedAnswer = answer.filter(a => a.questionId === questionId)
          let fullQuestion = []
          if (fullQuestionProvided) {
            fullQuestion[0] = question
          } else {
            fullQuestion = this.sortedQuestions.filter(q => q.id === questionId)
          }
          if (matchedAnswer && matchedAnswer.length && fullQuestion) {
            // console.log('matchedAnswer', matchedAnswer)
            // console.log('fullQuestion[0]', fullQuestion[0])
            if (fullQuestion && fullQuestion[0].questionType === 'text') {
              // console.log('text', matchedAnswer[0].openAnswer)
              finalAnswer = matchedAnswer[0].openAnswer
            } else if (fullQuestion[0].questionType === 'bool') {
              // console.log('bool', matchedAnswer[0].boolAnswer)
              finalAnswer = this.convertBoolMethod(matchedAnswer[0].boolAnswer)
            } else if (fullQuestion[0].questionType === 'select') {
              // console.log('select', parseInt(matchedAnswer[0].selectAnswer))
              if (matchedAnswer[0].selectAnswer) {
                const selectAnswer = fullQuestion[0].questionOption.filter(qo => qo.id === parseInt(matchedAnswer[0].selectAnswer))
                if (selectAnswer && selectAnswer.length && selectAnswer[0] && selectAnswer[0].optionText) {
                  finalAnswer = selectAnswer[0].optionText
                } else {
                  finalAnswer = ''
                }
              } else {
                finalAnswer = ''
              }
            } else if (fullQuestion[0].questionType === 'address') {
              // console.log('address', matchedAnswer[0].addressId)
              if (fullAddress && matchedAnswer[0].address) {
                finalAnswer = matchedAnswer[0].address
                // finalAnswer = `${matchedAnswer[0].address.line1} \n`
                // finalAnswer += `${matchedAnswer[0].address.line1} \n`
              } else if (addressPropReturn) {
                if (matchedAnswer[0].address) {
                  finalAnswer = matchedAnswer[0].address[addressPropReturn]
                } else {
                  finalAnswer = ''
                }
              } else {
                finalAnswer = matchedAnswer[0].addressId
              }
            }
          }
        }
      }
      // console.log('finalAnswer', finalAnswer)
      return finalAnswer
    },
    customQuestionColumns (columns) {
      return columns.filter(col => col.name.startsWith('q_'))
    },
    forceAttendeeBaseFormRerender () {
      this.attendeeBaseFormKey += 1
    },
    externalLink (url) {
      openURL(url)
    },
    registrationLink () {
      let url = ''
      if (this.environment === 'development') {
        url = this.eventInfo.eventRegistrationUrl ? this.eventInfo.eventRegistrationUrl : `http://agc.test/event-registration/${this.eventInfo.id}`
      } else if (this.environment === 'staging') {
        url = this.eventInfo.eventRegistrationUrl ? this.eventInfo.eventRegistrationUrl : `http://agc.test/event-registration/${this.eventInfo.id}`
      } else if (this.environment === 'live') {
        url = this.eventInfo.eventRegistrationUrl ? this.eventInfo.eventRegistrationUrl : `https://agcmn.org/event-registration/${this.eventInfo.id}`
      }
      console.log('url', url)
      // const url = this.eventInfo.eventRegistrationUrl ? this.eventInfo.eventRegistrationUrl : `http://agc.test/event-registration/${this.eventInfo.id}`
      openURL(url)
    },
    myFilter (rows, terms, cols, cellValue) {
      const lowerTerms = terms ? terms.toLowerCase() : ''
      return rows.filter(row => cols.some(col => (cellValue(col, row) + '').toLowerCase().indexOf(lowerTerms) !== -1))
    },
    getSelectOptions (question) {
      let options = []
      if (question && question.questionType === 'select' && question.questionOption && question.questionOption.length) {
        for (let option of question.questionOption) {
          let obj = {label: option.optionText, value: option.id.toString()}
          options.push(obj)
        }
      }
      return options
    },
    massSelectAction (type = null) {
      if (this.massSelectOptionSelected === 'accounting') {
        this.$q
          .dialog({
            title: 'Confirm',
            message: 'Are you sure that you wish to move all of the selected orders to accounting?',
            ok: 'Yes',
            cancel: 'No'
          })
          .then(() => {
            // this.$q.notify('Agreed!')
            // this.bulkMoveAccounting(type)
          })
          .catch(() => {
            // this.$q.notify('Disagreed...')
          })
      }
      this.massSelectOptionSelected = null
    },
    openTextModal (text) {
      this.textModalOpen = true
      this.textModalText = text
    },
    openEditModal (id) {
      this.editFormModelId = id
      let form = {}
      // console.log('id', id)
      if (id && this.attendees && this.attendees.length) {
        let tempForm = this.attendees.filter(attendee => attendee.id === id)
        // console.log('tempForm', tempForm)
        if (tempForm && tempForm.length) {
          form = extend(false, {}, tempForm[0])
        }
      }
      if (form.answer && !form.answer.length && this.sortedQuestions && this.sortedQuestions.length) {
        // let answerArray = []
        for (let question of this.sortedQuestions) {
          let answerModel = {
            addressId: null,
            boolAnswer: false,
            id: 0,
            openAnswer: '',
            personEventId: form.id,
            questionId: question.id,
            removalDate: null,
            selectAnswer: null
          }
          form.answer.push(answerModel)
        }
      }
      if (!form.attending) {
        form.attending = false
      } else {
        form.attending = true
      }
      // console.log('editForm', form)
      // this.editForm = form
      this.$set(this, 'editForm', form)
      this.editFormModalOpen = true
    },
    openBaseModal (id, resource) {
      // console.log('openBaseModal', 'id', id, 'resource', resource)
      this.baseFormModalOpen = true
      this.baseFormModelId = id
      this.relationResource = resource
    },
    handleNew (model) {
      console.log('handleNew', model)
    },
    handleBaseEdit (model) {
      // console.log('relationFields handleEdit', model)
      // console.log('handleBaseEdit', model)
      // this.relationResource = resource
      this.$q.notify({
        message: `Record Updated`,
        type: 'positive'
      })
      this.baseFormModalOpen = false
      this.baseFormModelId = false
      this.getAttendees()
      // this.request()
      // this.selected(model)
      // this.$set(this, 'editFormModalOpen', false)
    },
    editFormAddress (question) {
      // console.log('findAnswerIndex question', question)
      let answerIndex = this.findAnswerIndex(question)
      let answerType = this.findAnswerType(question)
      // console.log('answerIndex', answerIndex)
      // console.log('answerType', answerType)
      if (answerIndex >= 0 && answerType) {
        this.attendeeAddressBaseFormModelId = this.editForm.answer[answerIndex].id
        this.attendeeAddressEditFormAnswerIndex = answerIndex
        this.attendeeAddressBaseFormModalOpen = true
        // this.openBaseModal(this.editForm.answer[answerIndex].id, 'answer')
      } else {
        // TODO: Add New?
        this.attendeeAddressBaseFormModelId = ''
        this.attendeeAddressEditFormAnswerIndex = false
        this.attendeeAddressBaseFormModalOpen = true
        // this.openBaseModal('', 'answer')
      }
      // console.log('this.attendeeAddressBaseFormModelId', this.attendeeAddressBaseFormModelId)
    },
    async updateEditFormAddress (form) {
      // console.log('updateEditFormAddress', form)
      this.editForm.answer[this.attendeeAddressEditFormAnswerIndex].address = form.address
      this.editForm.answer[this.attendeeAddressEditFormAnswerIndex].addressId = form.address.id
      await this.getAttendees()
      this.attendeeAddressBaseFormModalOpen = false
      // this.attendeeAddressBaseFormModelId = ''
      // this.attendeeAddressEditFormAnswerIndex = false
    },
    // async handleAttendeeAddressBaseEdit (model) {
    //   // console.log('relationFields handleEdit', model)
    //   console.log('handleAttendeeAddressBaseEdit', model)
    //   // this.relationResource = resource
    //   this.$q.notify({
    //     message: `Attendee Address Updated`,
    //     type: 'positive'
    //   })
    //   this.attendeeAddressBaseFormModalOpen = false
    //   this.attendeeAddressBaseFormModelId = ''
    //   // We need to get the person model, this is not really apart of the personEvent
    //   // this.editForm.person = model
    //   // this.editForm.personId = model.id
    //   await this.getAttendees()
    //   // let attendee = this.attendees.filter(attendee => attendee.personId === model.personId)
    //   // this.$set(this.editForm, 'person', attendee[0].person)
    //   // this.$set(this.editForm, 'personId', attendee[0].personId)
    //   // console.log('attendee', attendee)
    //   // this.editForm.person = attendee[0].person
    //   // this.editForm.personId = attendee[0].personId
    // },
    openAttendeeBaseModal (id) {
      // console.log('openAttendeeBaseModal', 'id', id)
      this.attendeeBaseFormModelId = id
      // this.forceAttendeeBaseFormRerender()
      this.attendeeBaseFormModalOpen = true
      // this.attendeeRelationResource = resource
    },
    // async handleAttendeeBaseEdit (model) {
    //   // console.log('relationFields handleEdit', model)
    //   console.log('handleBaseEdit', model)
    //   // this.relationResource = resource
    //   this.$q.notify({
    //     message: `Attendee Updated`,
    //     type: 'positive'
    //   })
    //   this.attendeeBaseFormModalOpen = false
    //   this.attendeeBaseFormModelId = false
    //   // We need to get the person model, this is not really apart of the personEvent
    //   // this.editForm.person = model
    //   // this.editForm.personId = model.id
    //   await this.getAttendees()
    //   let attendee = this.attendees.filter(attendee => attendee.personId === model.personId)
    //   this.$set(this.editForm, 'person', attendee[0].person)
    //   this.$set(this.editForm, 'personId', attendee[0].personId)
    //   console.log('attendee', attendee)
    //   // this.editForm.person = attendee[0].person
    //   // this.editForm.personId = attendee[0].personId
    // },
    async updateEditFormAttendee (form) {
      this.editForm.person = form.person
      this.editForm.personId = form.person.id
      await this.getAttendees()
      this.attendeeBaseFormModalOpen = false
      // this.attendeeBaseFormModelId = ''
    },
    async saveAttendee () {
      const result = await this.$validator.validate(this.validatorFormName + '.*')
      if (!result) {
        this.$q.notify({
          message: 'Please complete all required fields',
          type: 'negative'
        })
        return
      }
      // console.log('save')
      // this.editForm.answer
      let answerError = false
      let personEventError = false
      let purchaseEventError = false
      // Answer Update
      for (let answer of this.editForm.answer) {
        let answerModel = extend(false, answer)
        answerModel.isDirty = true
        if (!answer.id) {
          answerModel.id = 0
          // POST
          try {
            const {data} = await this.$axios.post(`/api/answer/`, answerModel)
            if (data) {
              // console.log('POST Answer Saved: ', data)
              answer = data
            } else {
              answerError = true
            }
          } catch (e) {
            answerError = true
          }
        } else {
          // PUT
          try {
            delete answerModel.id
            const {data} = await this.$axios.put(`/api/answer/${answer.id}`, answerModel)
            if (data) {
              // console.log('PUT Answer Saved: ', data)
              answer = data
            } else {
              answerError = true
            }
          } catch (e) {
            answerError = true
          }
        }
      }
      // Person Update
      try {
        let personEventModel = extend(false, this.editForm)
        personEventModel.isDirty = true
        delete personEventModel.id
        delete personEventModel.answer
        delete personEventModel.event
        delete personEventModel.eventTeam
        delete personEventModel.person
        delete personEventModel.purchase
        delete personEventModel.primaryRegistrant
        const {data} = await this.$axios.put(`/api/personevent/${this.editForm.id}`, personEventModel)
        if (data) {
          // console.log('PUT PersonEvent Saved: ', data)
          // answer = data
        } else {
          personEventError = true
        }
      } catch (e) {
        personEventError = true
      }
      // Purchase Update
      if (this.editForm.purchase && this.editForm.purchase.id) {
        try {
          let purchaseModel = extend(false, this.editForm.purchase)
          purchaseModel.isDirty = true
          delete purchaseModel.id
          delete purchaseModel.eventDiscountPurchase
          delete purchaseModel.fundAccountType
          delete purchaseModel.payment
          delete purchaseModel.purchaseType
          delete purchaseModel.sponsorshipPurchase
          if (this.editForm.primaryRegistrant) {
            purchaseModel.personId = this.editForm.personId
          }
          const {data} = await this.$axios.put(`/api/purchase/${this.editForm.purchase.id}`, purchaseModel)
          if (data) {
            // console.log('PUT Purchase Saved: ', data)
            // answer = data
          } else {
            purchaseEventError = true
          }
        } catch (e) {
          purchaseEventError = true
        }
      }
      // Messaging
      if (personEventError || answerError || purchaseEventError) {
        this.$q.notify({
          message: 'Error saving'
        })
      } else {
        this.$q.notify({
          message: 'Form saved',
          type: 'positive'
        })
      }
      await this.getAttendees()
      this.editFormModalOpen = false
    },
    async getEvent () {
      try {
        const {data} = await this.$axios.get('/api/odata/event/paginate', {
          params: {
            $expand: 'EventType,EventTeam,EventDiscount,EventDate,Address,Sponsorship,Question($expand=QuestionOption)',
            $filter: `id eq ${this.eventId}`
          }
        })
        if (data && data.data && data.data[0]) {
          this.eventInfo = data.data[0]
        } else {
          this.$q.notify({
            message: 'Error fetching event data'
          })
        }
      } catch (e) {
        this.$q.notify({
          message: 'Error fetching event data'
        })
      }
    },
    async getAttendees () {
      try {
        const {data} = await this.$axios.get('/api/odata/personevent/paginate', {
          params: {
            $expand: 'EventTeam,Answer($expand=Address($expand=State)),Person($expand=Company($expand=Address($expand=State)),PersonDietOption($expand=DietOption)),Purchase($expand=PurchaseType,FundAccountType,Payment,SponsorshipPurchase($expand=Sponsorship),EventDiscountPurchase($expand=EventDiscount))',
            $filter: `eventId eq ${this.eventId} and removalDate eq null`,
            limit: 500
          }
        })
        if (data && data.data) {
          this.attendees = data.data
        } else {
          this.$q.notify({
            message: 'Error fetching attendee data'
          })
        }
      } catch (e) {
        this.$q.notify({
          message: 'Error fetching attendee data'
        })
      }
    },
    async handleBatchDelete () {
      // console.log('Dialog here then delete')
      this.$q
        .dialog({
          title: 'Confirm Delete of the selected attendees',
          message: 'Are you sure you want to remove the selected attendees? This does not affect purchase transactions. Please handle these in Quickbooks before deletion.',
          ok: {
            label: 'Delete',
            color: 'negative'
          },
          cancel: true
        })
        .then(() => {
          // console.log('this.selected', this.selected)
          if (this.selected && this.selected.length > 0) {
            for (let personEvent of this.selected) {
              if (personEvent.purchase) {
                // this.deletePurchaseRecords.push(personEvent.purchase)
                // this.$set(this.editForm, 'personId', attendee[0].personId)
                this.$set(this.deletePurchaseRecords, personEvent.purchase.id, personEvent.purchase)
              }
              const data = this.$axios
                .delete(`/api/personEvent/${personEvent.id}`)
                .then(response => {
                  if (data) {
                    // console.log(data)
                  }
                })
                .catch(error => {
                  console.log(error)
                })
            }
            this.checkIfPurchaseDeletable()
            this.selected = []
            this.getAttendees()
            this.$q.notify({
              message: `Attendees Deleted`,
              type: 'positive'
            })
            // console.log('deletePurchaseRecords', this.deletePurchaseRecords)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    async checkIfPurchaseDeletable () {
      // console.log('deletePurchaseRecords', this.deletePurchaseRecords)
      if (this.deletePurchaseRecords && this.deletePurchaseRecords.length > 0) {
        for (let purchase of this.deletePurchaseRecords) {
          if (purchase) {
            try {
              const {data} = await this.$axios.get('/api/odata/personevent/paginate', {
                params: {
                  $expand: 'EventTeam,Answer($expand=Address($expand=State)),Person($expand=Company($expand=Address($expand=State)),PersonDietOption($expand=DietOption)),Purchase($expand=PurchaseType,FundAccountType,Payment,SponsorshipPurchase($expand=Sponsorship),EventDiscountPurchase($expand=EventDiscount))',
                  $filter: `purchaseId eq ${purchase.id} and removalDate eq null`,
                  limit: 500
                }
              })
              // console.log('checkIfPurchaseDeletable data', data)
              if (data && data.data && data.data.length) {
                // console.log('leftover personEvent', data.data)
                // Nothing
              } else {
                // console.log('no data, start deletePurchase')
                await this.deletePurchase(purchase)
                // return purchase.id
              }
            } catch (e) {
              this.$q.notify({
                message: 'Error fetching attendee data'
              })
            }
          }
        }
        this.$set(this, 'deletePurchaseRecords', [])
      }
    },
    async deletePurchase (purchase) {
      // console.log('deletePurchase', purchase.id)
      try {
        const data = this.$axios
          .delete(`/api/purchase/${purchase.id}`)
          .then(response => {
            if (data) {
              // console.log(data)
            }
          })
          .catch(error => {
            console.log(error)
          })
      } catch (e) {
        this.$q.notify({
          message: 'Error deleting related purchase'
        })
      }
      if (purchase.sponsorshipPurchase && purchase.sponsorshipPurchase.length) {
        for (let sp of purchase.sponsorshipPurchase) {
          if (sp.id) {
            // console.log('delete purchase.sponsorshipPurchase', purchase.sponsorshipPurchase.id)
            try {
              const data = this.$axios
                .delete(`/api/sponsorshipPurchase/${sp.id}`)
                .then(response => {
                  if (data) {
                    // console.log(data)
                  }
                })
                .catch(error => {
                  console.log(error)
                })
            } catch (e) {
              this.$q.notify({
                message: 'Error deleting related Sponsorship purchase'
              })
            }
          }
        }
      }
      if (purchase.eventDiscountPurchase && purchase.eventDiscountPurchase.length) {
        for (let edp of purchase.eventDiscountPurchase) {
          if (edp.id) {
            try {
              const data = this.$axios
                .delete(`/api/eventDiscountPurchase/${edp.id}`)
                .then(response => {
                  if (data) {
                    // console.log(data)
                  }
                })
                .catch(error => {
                  console.log(error)
                })
            } catch (e) {
              this.$q.notify({
                message: 'Error deleting related Event Discount purchase'
              })
            }
          }
        }
      }
    }
  }
}
// List of Persons
// Company [person_event, person, person_company]
// Dietary Requirements !! [person_event, person, person_diet_option]
// ADA Accessibility Requirements !! [person_event, person]
// More Info (Click to view these details)
// Address [person_event, person, address]
// Comments [person_event]

// Payment Status (Paid / Invoiced) [purchase]
// Payment Info !! (Modal Link to view all payment details and option to refund or edit - Communicates with Quickbooks Payments or Quickbooks Online depending if the transaction was Invoiced or paid via Credit Card)
// Quickbooks Transaction ID !! (if paid with Credit Card - Link to QB Online Transaction or easy copy option - Example: https://c28.qbo.intuit.com/app/recvpayment?txnId=10772) [purchase]
// Invoice ID !! (if Invoice Me option was used - Link to QB Online Invoice or easy copy option - Example: https://c28.qbo.intuit.com/app/invoice?txnId=6082) [purchase]
// Amount [purchase]
// Discount Applied [purchase, discount]
// Date [purchase]
</script>

<style scoped></style>
